import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {RestApi} from '../RestApi/restApi';
import {Router} from '@angular/router';

interface CustomTemplateReportInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}
@Injectable({
  providedIn: 'root'
})
export class CustomTemplateReportService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router
  ) { }

  runCustomReportGenerationManually(repotId,dnsId) {

    return this.http.get<CustomTemplateReportInfo>(this.restAPI.RUNCUSTOMREPORTGENERATIONMANUALLY+"/"+repotId+"/"+dnsId, { headers: this.headers });

  }
  retrieveGeneratedReportList(customReportId,dnsId,startDate,endDate){
    return this.http.get<CustomTemplateReportInfo>(this.restAPI.RETRIEVEGENERATEDREPORTLIST+`/${customReportId}/${dnsId}/${startDate}/${endDate}`, { headers: this.headers });

  }
}
